(function () {
  'use strict';

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderPriceSurfaces(sec) {
    var mode = sec.dataset.purchaseMode || 'subscribe';
    var total = parseInt(sec.dataset.totalCents, 10) || 0;
    var onetimeCents = parseInt(sec.dataset.onetimeCents, 10) || 0;
    var subCents = parseInt(sec.dataset.subCents, 10) || 0;
    var onetimePct = parseFloat(sec.dataset.onetimePct) || 0;
    var subPct = parseFloat(sec.dataset.subPct) || 0;
    var days = parseFloat(sec.dataset.daysOfSupply) || 0;

    function resolve(v) { return v === 'current' ? mode : v; }
    function bundleFor(m) { return m === 'subscribe' ? subCents : onetimeCents; }
    function pctFor(m) { return m === 'subscribe' ? subPct : onetimePct; }

    sec.querySelectorAll('[data-stack-price]').forEach(function (el) {
      el.textContent = fmt(bundleFor(resolve(el.getAttribute('data-stack-price'))));
    });
    sec.querySelectorAll('[data-stack-compare]').forEach(function (el) {
      el.textContent = fmt(total);
    });
    sec.querySelectorAll('[data-stack-save]').forEach(function (el) {
      var m = resolve(el.getAttribute('data-stack-save'));
      var bundle = bundleFor(m);
      el.textContent = 'Save ' + pctFor(m) + '% · ' + fmt(total - bundle) + ' off';
    });
    sec.querySelectorAll('[data-stack-cost-per-day]').forEach(function (el) {
      if (!days) return;
      var m = resolve(el.getAttribute('data-stack-cost-per-day'));
      el.textContent = fmt(Math.round(bundleFor(m) / days)) + '/day';
    });
  }

  function updateStack(sec) {
    var onetimePct = parseFloat(sec.dataset.onetimePct) || 0;
    var subPct = parseFloat(sec.dataset.subPct) || 30;

    if (!sec.dataset.bundleVariantId) {
      // No real bundle product wired up for this section — fall back to summing
      // the on-page component cards (legacy behaviour, e.g. cp-science.liquid).
      var totalCents = 0;
      sec.querySelectorAll('.aa-products [data-variant-id]').forEach(function (card) {
        var priceEl = card.querySelector('[data-price-one]');
        totalCents += priceEl ? parseInt(priceEl.dataset.priceOne, 10) || 0 : 0;
      });
      sec.dataset.totalCents = totalCents;
      sec.dataset.onetimeCents = Math.round(totalCents * (1 - onetimePct / 100));
      sec.dataset.subCents = Math.round(totalCents * (1 - subPct / 100));
    }
    // Otherwise the section already carries the real bundle-product pricing
    // (data-total-cents / data-onetime-cents / data-sub-cents) rendered server-side.

    renderPriceSurfaces(sec);
  }

  function initVariants(card) {
    var script = card.querySelector('.aa-variants-data');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var initialId = parseInt(card.dataset.variantId, 10);
    var first = variants.find(function (v) { return v.id === initialId; })
      || variants.find(function (v) { return v.available; })
      || variants[0];
    var selected = first.options.slice();
    card.dataset.variantId = first.id;

    function sync() {
      var match = variants.find(function (v) {
        return selected.every(function (o, i) { return v.options[i] === o; });
      });
      if (!match) return;
      card.dataset.variantId = match.id;
      var sec = card.closest('.cpg');

      var addBtn = card.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (!match.available) { addBtn.textContent = 'Sold Out'; }
        else if (addBtn.textContent === 'Sold Out') { addBtn.textContent = 'Add to Cart'; }
      }

      var priceEl = card.querySelector('[data-price-one]');
      if (priceEl && match.price !== undefined) {
        var subPct = (sec && parseFloat(sec.dataset.subPct)) || 30;
        var subCents = Math.round(match.price * (1 - subPct / 100));
        priceEl.dataset.priceOne = match.price;
        priceEl.dataset.priceSub = subCents;
        var isSub = card.closest('[data-sub]') && card.closest('[data-sub]').dataset.sub === '1';
        priceEl.textContent = isSub ? fmt(subCents) : fmt(match.price);
      }
      var cmpEl = card.querySelector('[data-compare-price]');
      if (cmpEl) {
        cmpEl.textContent = match.compare_at_price ? fmt(match.compare_at_price) : '';
      }

      if (sec) updateStack(sec);
    }

    card.querySelectorAll('[data-option-1]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[0] = this.getAttribute('data-option-1');
        card.querySelectorAll('[data-option-1]').forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        sync();
      });
    });

    var sel2 = card.querySelector('[data-option-2-select]');
    if (sel2) {
      sel2.addEventListener('change', function () {
        selected[1] = this.value;
        sync();
      });
    }
  }

  async function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });
      if (!res.ok) throw new Error('cart');
      btn.textContent = '✓ Added!';
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:drawer:change'));
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2000);
    } catch (e) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  async function addStackToCart(sec, mode, btn) {
    mode = mode || 'onetime';
    var items = [];
    if (sec.dataset.bundleVariantId) {
      var bundleItem = { id: parseInt(sec.dataset.bundleVariantId, 10), quantity: 1 };
      if (mode === 'subscribe' && sec.dataset.bundleSellingPlanId) {
        bundleItem.selling_plan = parseInt(sec.dataset.bundleSellingPlanId, 10);
      }
      items.push(bundleItem);
    } else {
      sec.querySelectorAll('[data-variant-id]').forEach(function (card) {
        var id = card.dataset.variantId;
        if (!id) return;
        var item = { id: parseInt(id, 10), quantity: 1 };
        if (mode === 'subscribe' && card.dataset.sellingPlanId) {
          item.selling_plan = parseInt(card.dataset.sellingPlanId, 10);
        }
        items.push(item);
      });
    }
    if (!items.length) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('cart');
      btn.textContent = '✓ All Added!';
      document.dispatchEvent(new CustomEvent('cart:drawer:change'));
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 2500);
    } catch (e) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  function initFaq(sec) {
    sec.querySelectorAll('.aa-faq-item__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        this.closest('.aa-faq-item').classList.toggle('is-open');
      });
    });
  }

  function initSellingPlanSelect(sec) {
    var selects = sec.querySelectorAll('[data-selling-plan-select]');
    if (!selects.length) return;

    function applyChoice(chosenSelect) {
      var opt = chosenSelect.selectedOptions[0];
      if (!opt) return;
      sec.dataset.bundleSellingPlanId = opt.value;
      var pct = parseFloat(opt.dataset.pct);
      if (!isNaN(pct)) {
        sec.dataset.subPct = pct;
        var total = parseInt(sec.dataset.totalCents, 10) || 0;
        sec.dataset.subCents = Math.round(total * (1 - pct / 100));
      }
      selects.forEach(function (other) {
        if (other !== chosenSelect) other.value = opt.value;
      });
      renderPriceSurfaces(sec);
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () { applyChoice(select); });
    });
  }

  function initPurchaseMode(sec) {
    sec.querySelectorAll('[data-purchase-mode-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!this.checked) return;
        sec.dataset.purchaseMode = this.value;
        renderPriceSurfaces(sec);
      });
    });
  }

  function initMobileSticky(sec) {
    var bar = sec.querySelector('[data-mobile-sticky]');
    var heroCard = sec.querySelector('.aa-hero__card');
    var buyBox = sec.querySelector('.aa-stack__card');
    if (!bar || !heroCard || !buyBox) return;

    var pastHero = false;
    var buyBoxVisible = false;
    var cartOpen = false;

    function render() {
      bar.classList.toggle('is-visible', pastHero && !buyBoxVisible && !cartOpen);
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      pastHero = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      render();
    }).observe(heroCard);

    new IntersectionObserver(function (entries) {
      buyBoxVisible = entries[0].isIntersecting;
      render();
    }).observe(buyBox);

    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      cartOpen = !cartDrawer.classList.contains('hdt-hidden');
      new MutationObserver(function () {
        cartOpen = !cartDrawer.classList.contains('hdt-hidden');
        render();
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function initSection(sec) {
    initPurchaseMode(sec);
    initMobileSticky(sec);
    initSellingPlanSelect(sec);

    sec.querySelectorAll('.aa-card, .aa-split-card').forEach(function (card) {
      initVariants(card);
      var addBtn = card.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addToCart(card.dataset.variantId, this);
        });
      }
    });

    sec.querySelectorAll('[data-stack-add-all]').forEach(function (stackBtn) {
      if (stackBtn.tagName === 'A') return;
      stackBtn.addEventListener('click', function () {
        var modeAttr = this.getAttribute('data-stack-add-all');
        var mode = modeAttr === 'subscribe' ? 'subscribe'
          : modeAttr === 'current' ? (sec.dataset.purchaseMode || 'onetime')
          : 'onetime';
        addStackToCart(sec, mode, this);
      });
    });

    updateStack(sec);

    initFaq(sec);
  }

  function boot() {
    document.querySelectorAll('.cpg:not([data-aa-inited])').forEach(function (sec) {
      sec.setAttribute('data-aa-inited', '1');
      initSection(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
